'use client'
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useState, useCallback, useEffect } from 'react';
import ButtonsPages from './legacy_blocks/ButtonsPages';
import DisabilityBlock from './legacy_blocks/DisabilityBlock';
import AddButton from '@egalite/ui/Buttons';
import { useRouter } from 'next/navigation';
import findIndex from 'lodash/findIndex';
import { useNotification } from '@egalite/ui/IncluiPCD/NotificationProvider';
import authFetch from '../../lib/auth/authFetch';
import Cookies from 'js-cookie';
import Loading from '@egalite/ui/Loading';
import FormPage from './legacy_blocks/CandidateFormPage';
import Button from '@egalite/ui/Buttons';

const nextIncomplete = (dList) => {
	if(!Array.isArray(dList)) {
		return -1
	}
	return findIndex(dList, d => !d.complete)
}

const DisabilityDataIndexForm = ({edit=false}) => {

	const [disabilityList, setDisabilityList] = useState([]);
	const [nextIncompleteIndex, setNextIncompleteIndex] =  useState(-1)

	const router = useRouter();
	const notification = useNotification();
	const [loadingData, setLoadingData] = useState(true);
	const [candidateData, setCandidateData] = useState<{education?: any[]}>({});

	useEffect(() => {
		setNextIncompleteIndex(nextIncomplete(disabilityList))
	}, [disabilityList])

	useEffect(() => {
		if (loadingData) {
			authFetch('/api/v2/candidate/profile', Cookies.get('token'))
				.then(res => res.json())
				.then(data => {
					if (data.success === true && data != null) {
						if(data.data.disability == null || data.data.disability.length > 0) {
							setDisabilityList(data.data.disability);
						} else {
							router.push('/candidato/form/disabilityData');
						}
						setCandidateData(data.data);
						setLoadingData(false);
					} else {
						notification.error('Erro ao carregar dados do candidato');
					}
				});
		}
	}, [router, loadingData, notification]);

	if (loadingData) {
		return <Loading fullScreen={true}>carregando dados</Loading>;
	}


	return (
		
		<FormPage
		actualStep={4}
		formActualStep={1}
		formTotalSteps={2}
		progress={50}
		formTitle={'Dados cadastrais'}
		// previousForm="/"
		showStepsMenu={false}
		// showBackButton={false}
		modal={edit}
	>
		<form>
			<div className="mb-16 md:mb-24">
				<div css={{ marginTop: edit ? '3.6rem' : 60 }}>
					{(disabilityList || []).map((item, index) => (
						<DisabilityBlock 
							key={index} 
							disability={item.disabilityType}
							link={edit ? `/candidato/form/edit?page=disabilityData&n=${index}` : `/candidato/form/disabilityData?n=${index}`} 
							/>
					))}
				</div>

				<AddButton 
					onClick={(e) => {
						e.preventDefault();
						edit ? router.push('/candidato/form/edit?page=disabilityData') : router.push('/candidato/form/disabilityData')}} >
						Tenho deficiência múltipla
				</AddButton>

				<div className='md:mt-24 mt-16'>
					{edit ?
						<Button type='submit' variant='primary' className='w-full'>Salvar</Button>
						:
						<ButtonsPages 
							previousForm={'/candidato/form/professionalDataExperienceIndex'} 
							next={nextIncompleteIndex > -1 
									? `/candidato/form/disabilityDataDescription?n=${nextIncompleteIndex}`
									: '/candidato/form/disabilityDataUpload'} 
							hideBack={edit} hideNext={edit} />
					}
				</div>
			</div>
			</form>
		</FormPage>
	);
}

export default DisabilityDataIndexForm;